const sidebarReducer = (state = {isCollapsed: false}, action) => {
    switch(action.type) {
        case "OPEN_SIDEBAR": {
            return {...state, isCollapsed: true}
        }
        case "CLOSE_SIDEBAR": {
            return {...state, isCollapsed: false}
        }
        default: {
            return state;
        }
    }
}

export default sidebarReducer